import React, { useEffect } from 'react';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import { Box, TextField } from '@mui/material';
// import CKEditor from 'ckeditor4-react';
import { useState, Downgraded, createState } from '@hookstate/core';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import Helper from '../../utility/helper';
import validator from 'validator';
import { useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import { makeStyles } from '@mui/styles';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import trash from '../../assets/images/trash.svg';
import { isEmpty } from 'lodash-es';


// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import Editor from 'ckeditor5-custom-build/build/ckeditor';
import TinyMCEEditor from '../../sharedcomponents/tinymceEditor/tinymce';

const settingState = createState({
    invitationID: 0,
    userID: 0,
    templateID: 0,
    templateName: '',
    emailID: '',
    ccEmailID: '',
    bccEmailID: '',
    body: '',
    subject: '',
    attachments: [],
});

const useStyles = makeStyles(() => ({
    fileInput: {
        display: 'flex',
        flex: '1',
        alignItems: 'center',
    },
    iconClass: {
        height: 20,
    },
    iconWidth: {
        width: 21,
        height: 21,
    },
}));

const SendEMail = (props) => {
    const classes = useStyles();
    const state = useState(settingState);
    // const authState = useAuthState();
    const invitationtemplateInfo = useState(null);
    const userInfo = useState(null);
    const eventData = useState(null);
    const [ccEmailErr, setCCEmailErr] = React.useState('');
    const [bccEmailErr, setBCCEmailErr] = React.useState('');
    const [emailErr, setEmailErr] = React.useState('');
    let params = useParams();
    const [loading, setLoading] = React.useState(false);
    const [toClicked, setToClicked] = React.useState(false);
    const [ccClicked, setCCClicked] = React.useState(false);
    const [bccClicked, setBCCClicked] = React.useState(false);
    const showLoading = true;

    useEffect(() => {
        const guserInfo = Helper.getStorage('userInfo');
        const eventInfo = Helper.getStorage('eventInfo');
        userInfo.set(guserInfo);
        if (
            eventData.get() == null ||
            (eventData.get() && eventData.eventID.value != eventInfo.eventID)
        ) {
            eventData.set(eventInfo);
        }
    }, []);

    useEffect(() => {
        if (props.invitationInfo) {
            const newinvitationInfo = props.invitationInfo;

            if (newinvitationInfo != null) {
                invitationtemplateInfo.set(newinvitationInfo);

                let invtemplateObj = {
                    invitationID: newinvitationInfo.invitationID,
                    userID: newinvitationInfo.userID,
                    templateID: newinvitationInfo.templateID,
                    templateName: newinvitationInfo.templateName,
                    emailID: newinvitationInfo.emailID,
                    ccEmailID: newinvitationInfo.ccEmailID,
                    bccEmailID: newinvitationInfo.bccEmailID,
                    body: newinvitationInfo.body,
                    subject: newinvitationInfo.subject,
                    attachments: newinvitationInfo.attachments,
                };
                state.set(invtemplateObj);
                getConnection(
                    'ccEmailID',
                    state.get().ccEmailID
                )
            }
        }
    }, []);

    const getConnection = (key, paramEmail) => {
        if (key === 'emailID') setToClicked(true);
        if (key === 'ccEmailID') setCCClicked(true);
        if (key === 'bccEmailID') setBCCClicked(true);

        const connections = [];
        ApiHelper.get(
            APIURLConstants.GET_CONNECTIONS(state.get().userID, eventData.get().eventID)
        ).then((res) => {
            if (res.data.length > 0) {
                res.data.forEach((connectionmail) => {
                    connections.push(
                        connectionmail.email,
                    );
                });
            }
            let SelectedEmails = [];
            const email = paramEmail != null ? paramEmail : '';
            if (email) SelectedEmails = email.split(',');
            const MergedArray = [...SelectedEmails, ...connections];
            if (email) {
                var coll = '';
                const uniqueEmail = [...new Set(MergedArray)];
                uniqueEmail.map((item) => {
                    if (coll) coll = coll + ',' + item;
                    else coll = item;
                });
                state[key].set(coll);
            } else {
                state[key].set(connections.join(','));
            }
        });


    };

    const isEmailValidate = () => {
        let flag = true;
        const email =
            state.emailID.attach(Downgraded).get() != null ? state.emailID.attach(Downgraded).get().trim() : '';
        let selectedEmails = [];
        if (email) {
            selectedEmails = email.split(',');
            selectedEmails.map((item) => {
                flag = item != '' ? validateEmail(item) : true;
                flag
                    ? setEmailErr('')
                    : setEmailErr('Please enter valid To Email');
            });
        } else setEmailErr('');
        return flag;
    };

    const isCCEmailValidate = () => {
        let flag = true;
        let email =
            state.ccEmailID.attach(Downgraded).get() != null ? state.ccEmailID.attach(Downgraded).get() : '';
        email = email.trim();
        let selectedEmails = [];
        if (email) {
            selectedEmails = email.split(',');
            selectedEmails.map((item) => {
                flag = item != '' ? validateEmail(item) : true;
                flag
                    ? setCCEmailErr('')
                    : setCCEmailErr('Please enter valid CC Email');
            });
        } else setCCEmailErr('');
        return flag;
    };

    const isBCCEmailValidate = () => {
        let flag = true;
        const email =
            state.bccEmailID.attach(Downgraded).get() != null ? state.bccEmailID.attach(Downgraded).get() : '';
        let selectedEmails = [];
        if (email) {
            selectedEmails = email.split(',');
            selectedEmails.map((item) => {
                flag = item != '' ? validateEmail(item) : true;
                flag
                    ? setBCCEmailErr('')
                    : setBCCEmailErr('Please enter valid BCC Email');
            });
        } else setBCCEmailErr('');
        return flag;
    };

    const validateEmail = (value) => {
        value = value.trim();
        if (validator.isEmail(value)) {
            return true;
        } else return false;
    };

    const handleFileChange = async (e) => {
        var targetFiles = e.target.files;
        const files = state.attachments.get()
            ? [...state.attachments.attach(Downgraded).get()]
            : [];
        // console.log("targetFiles",typeof targetFiles, Object.values(targetFiles));

        Object.values(targetFiles).forEach((item) => {
            const file = item;
            let blob = file.slice(0, file.size, file.type);
            let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
            let fileName = file.name.substring(0, file.name.lastIndexOf('.'));
            let newFileName =
                fileName + '_' + new Date().getTime() + '.' + extension;
            const newFile = new File([blob], newFileName, {
                type: file.type,
            });
            files.push({
                fileName: newFileName,
                createdDate:
                    Helper.FormatYearDate(new Date()) +
                    ' ' +
                    Helper.FormatTime24(new Date()),
                createdBy: userInfo.attach(Downgraded).get().userID,
                isAvailableAtBlob: false,
                file: newFile,
            });
        });

        state.attachments.set(files);
    };

    const handleRemove = (index) => {
        const values = [...state.attach(Downgraded).get().attachments];
        values.splice(index, 1);
        state.attachments.set(values);
        const dt = new DataTransfer();
        const input = document.getElementById('files');
        const { files } = input;

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (index !== i) dt.items.add(file); // here you exclude the file. thus removing it.
        }
        input.files = dt.files; // Assign the updates list
    };
    const setEditorValue = (value) => {
        state.body.set(value);
    }
    const renderDialogContent = () => {
        return (
            <>
                <Box>
                    <Box>
                        <TextField
                            fullWidth
                            sx={{
                                marginRight: 2,
                            }}
                            value={state.templateName.get()}
                            onChange={(e) => {
                                state.templateName.set(e.target.value);
                            }}
                            size="small"
                            id="outlined-required"
                            disabled
                            label="Template Name"
                        />
                    </Box>
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}>
                        <TextField
                            fullWidth
                            sx={{
                                marginTop: 2,
                                marginRight: props.view ? 0 : 2,
                            }}
                            size="small"
                            id="outlined-required"
                            label="To"
                            value={state.emailID.get()}
                            disabled={props.view ? true : false}
                            onChange={(e) => {
                                state.emailID.set(e.target.value);
                            }}
                            onBlur={() =>
                                params.userID > 0 ? null : isEmailValidate()
                            }
                            error={emailErr.length > 0 ? true : false}
                            helperText={emailErr.length > 0 ? emailErr : ''}
                        />
                        {props.view ? null : <GroupOutlinedIcon
                            fontSize="small"
                            style={toClicked ? { fill: 'green' } : {}}
                            onClick={() =>
                                getConnection('emailID', state.get().emailID)
                            }
                        />}
                    </Box>
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}
                        sx={{ marginTop: '10px' }}>
                        <TextField
                            fullWidth
                            sx={{
                                marginRight: props.view ? 0 : 2,
                            }}
                            value={state.ccEmailID.get()}
                            size="small"
                            id="outlined-required"
                            label="CC"
                            disabled={props.view ? true : false}
                            onChange={(e) => {
                                state.ccEmailID.set(e.target.value);
                            }}
                            onBlur={() =>
                                params.userID > 0 ? null : isCCEmailValidate()
                            }
                            error={ccEmailErr.length > 0 ? true : false}
                            helperText={ccEmailErr.length > 0 ? ccEmailErr : ''}
                        />
                        {props.view ? null : <GroupOutlinedIcon
                            fontSize="small"
                            style={ccClicked ? { fill: 'green' } : {}}
                            onClick={() =>
                                getConnection(
                                    'ccEmailID',
                                    state.get().ccEmailID
                                )
                            }
                        />}
                    </Box>
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}
                        sx={{ marginTop: '10px' }}>
                        <TextField
                            fullWidth
                            sx={{
                                marginRight: props.view ? 0 : 2,
                            }}
                            value={state.bccEmailID.get()}
                            size="small"
                            id="outlined-required"
                            label="BCC"
                            disabled={props.view ? true : false}
                            onChange={(e) => {
                                state.bccEmailID.set(e.target.value);
                            }}
                            onBlur={() =>
                                params.userID > 0 ? null : isBCCEmailValidate()
                            }
                            error={bccEmailErr.length > 0 ? true : false}
                            helperText={
                                bccEmailErr.length > 0 ? bccEmailErr : ''
                            }
                        />
                        {props.view ? null : <GroupOutlinedIcon
                            fontSize="small"
                            style={bccClicked ? { fill: 'green' } : {}}
                            onClick={() =>
                                getConnection(
                                    'bccEmailID',
                                    state.get().bccEmailID
                                )
                            }
                        />}
                    </Box>

                    <Box sx={{ marginTop: '10px' }}>
                        <TextField
                            fullWidth
                            required
                            sx={{
                                marginTop: 2,
                                marginRight: 2,
                            }}
                            size="small"
                            disabled={props.view ? true : false}
                            value={state.subject.get()}
                            onChange={(e) => {
                                state.subject.set(e.target.value);
                            }}
                            id="outlined-required"
                            label="Subject"
                        />
                    </Box>
                    <Box
                        sx={{
                            flex: 1,
                            flexDirection: 'row',
                            marginTop: 2,
                            width: { xs: '100%', md: '100%' },
                        }}>
                        {/* <CKEditor
                            data={state.body.attach(Downgraded).get()}
                            onChange={(event) =>
                                state.body.set(event.editor.getData())
                            }
                            config={{
                                removeButtons: 'Subscript,Superscript',
                                extraAllowedContent: '*{*};*(*);span{!color}'
                            }}
                        /> */}
                        <TinyMCEEditor
                            value={state.body.attach(Downgraded).get()}
                            setValue={setEditorValue}
                            enableImageEncode={true}  
                        />
                        {/* <CKEditor
                            editor={Editor}
                            config={{
                                image: {
                                    upload: ['jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff']
                                },
                                removeButtons: 'Subscript,Superscript',
                                extraAllowedContent: '*{*};*(*);span{!color}'
                            }}
                            disabled={props.view?true:false}
                            data={state.body.attach(Downgraded).get()}
                            onChange={(event, editor) => {
                                console.log(event);
                                state.body.set(editor.getData())
                            }}                          
                        /> */}
                    </Box>
                    <>
                        {/* Start Display Attachment List Here */}
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                backgroundColor: '#f8f8f8',
                                flex: 1,
                                marginTop: '10px',
                            }}>
                            <Box flex={0.98}>
                                <Typography
                                    variant="h4"
                                    fontSize={{ xs: '12px', md: '16px' }}
                                    fontWeight={500}
                                    paddingLeft={1}
                                    paddingTop={1}
                                    pb={1}>
                                    Attachments
                                </Typography>
                            </Box>
                            <label>{props.view ? null :
                                <Box
                                    sx={{
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        alignSelf: 'center',
                                        display: 'flex',
                                    }}
                                    flex={0.03}
                                    id="imageUpload">
                                    <AddCircleRoundedIcon
                                        sx={{ color: '#008000' }}
                                    />
                                    <input
                                        type="file"
                                        id="files"
                                        multiple={true}
                                        hidden
                                        onChange={handleFileChange}
                                    />
                                </Box>
                            }
                            </label>
                        </Box>

                        {state.attachments.attach(Downgraded).get() &&
                            state.attachments.attach(Downgraded).get().length >
                            0 ? (
                            <>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        flex: 1,
                                        marginTop: 1,
                                        backgroundColor: '#f8f8f8',
                                    }}>
                                    <Box
                                        flex={0.65}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'start',
                                            lineHeight: '0',
                                        }}>
                                        <Typography
                                            variant="h2"
                                            fontSize={12}
                                            fontWeight={500}
                                            paddingLeft={1}
                                            paddingTop={1}
                                            sx={{ paddingLeft: 5 }}
                                            color={'primary'}
                                            pb={1}>
                                            File Name
                                        </Typography>
                                    </Box>
                                    <Box
                                        flex={0.3}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'start',
                                            lineHeight: '0',
                                        }}>
                                        <Typography
                                            variant="h2"
                                            fontSize={12}
                                            fontWeight={500}
                                            paddingLeft={1}
                                            paddingTop={1}
                                            sx={{ paddingLeft: 5 }}
                                            color={'primary'}
                                            pb={1}>
                                            Created Date
                                        </Typography>
                                    </Box>
                                </Box>
                                {state.attachments.attach(Downgraded).get() &&
                                    state.attachments
                                        .attach(Downgraded)
                                        .get()
                                        .map((file, idx) => {
                                            let extension = file.fileName.substring(file.fileName.lastIndexOf('.') + 1);
                                            let fileName = file.fileName.substring(0, file.fileName.lastIndexOf('.'));
                                            return (
                                                <Box
                                                    key={idx}
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        flex: 1,
                                                        marginTop: 1,
                                                        backgroundColor:
                                                            '#f8f8f8',
                                                    }}>
                                                    <Box
                                                        flex={0.65}
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            justifyContent:
                                                                'start',
                                                            lineHeight: '0',
                                                        }}>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={14}
                                                            fontWeight={400}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            pb={1}>
                                                            {Helper.removeLastChars(fileName, 14) + '.' + extension}
                                                        </Typography>
                                                    </Box>
                                                    <Box
                                                        flex={0.3}
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            justifyContent:
                                                                'start',
                                                            lineHeight: '0',
                                                        }}>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={14}
                                                            fontWeight={400}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            pb={1}>
                                                            {`${Helper.FormatYearDate(
                                                                file.createdDate
                                                            )} ${Helper.FormatTime24(
                                                                file.createdDate
                                                            )}`}
                                                        </Typography>
                                                    </Box>
                                                    {props.view ? null :
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems:
                                                                    'center',
                                                                flex: 0.05,
                                                            }}>
                                                            <Box
                                                                component="img"
                                                                className={
                                                                    classes.sedanBlack
                                                                }
                                                                alt="logo."
                                                                src={trash}
                                                                onClick={() =>
                                                                    handleRemove(
                                                                        idx
                                                                    )
                                                                }
                                                            />
                                                        </Box>
                                                    }
                                                </Box>
                                            );
                                        })}{' '}
                            </>
                        ) : null}
                        {/* End Display Attachment List Here */}
                    </>
                </Box>
            </>
        );
    };

    const renderDialogActions = () => {
        return (
            <ButtonContainer
                handleClick={handleClick}
                handleCancel={props.handleClose}
                buttonText={'Send'}
                loading={loading}
                showLoading={showLoading}
                disableUpdateButton={props.view ? true : false}
            />
        );
    };
    const handleClick = async () => {
        const toValid = isEmailValidate();
        const ccValid = isCCEmailValidate();
        const bccValid = isBCCEmailValidate();
        if (ccValid == false || bccValid == false || toValid == false) {
            return false;
        }

        if (
            (isEmpty(state.get().emailID) ||
                state.get().emailID == undefined) &&
            (isEmpty(state.get().ccEmailID) ||
                state.get().ccEmailID == undefined) &&
            (isEmpty(state.get().bccEmailID) ||
                state.get().bccEmailID == undefined)
        ) {
            let message =
                'We need to know who to send this to. Make sure you enter at least one name.';

            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: message, //'Error while Send Email',
            });
            return false;
        }

        if (state.get().subject == '') {
            let message = 'Please fill out subject';

            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: message, //'Error while Send Email',
            });
            return false;
        }

        let formData = new FormData();
        // //Adding files to the form data
        formData.append('InvitationID', state.get().invitationID);
        formData.append('UserID', state.get().userID);
        formData.append('TemplateID', state.get().templateID);
        formData.append('EmailID', state.get().emailID);
        formData.append('CCEmailID', state.get().ccEmailID);
        formData.append('BCCEmailID', state.get().bccEmailID);
        formData.append('Body', state.get().body ? encodeURIComponent(state.get().body) : '');
        formData.append('Subject', state.get().subject);
        formData.append('createdBy', userInfo.attach(Downgraded).get().userID);
        formData.append('modifiedBy', userInfo.attach(Downgraded).get().userID);
        formData.append('eventID', eventData.get().eventID);
        formData.append('ModuleID', 3);

        state.attachments.attach(Downgraded).get() &&
            state.attachments
                .attach(Downgraded)
                .get()
                .forEach((file) => {
                    if (file.file) {
                        let newFile = file.file;
                        formData.append('Attachments', newFile);
                    }
                    else {
                        formData.append('ExistingAttachments', file.fileName);
                    }
                });

        setLoading(true);
        ApiHelper.post(APIURLConstants.POST_SEND_EMAIL, formData)
            .then((res) => {
                if (res.data) {
                    setLoading(false);
                    if (res.data == 'Email Sent successfully') {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Email Sent successfully',
                        });
                    } else {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Email Sent Failed',
                        });
                    }
                    if (invitationtemplateInfo) {
                        props.getInvitationList();
                    }
                }
                props.handleClose();
            })
            .catch((error) => {
                setLoading(false);
                var msg = 'Error while Send Email';
                if (error.response.data == 'Please add subject Or body')
                    msg = 'Please add subject Or body';
                if (error.response && error.response.status === 401) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Access denied',
                    });
                } else {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: msg, //'Error while Send Email',
                    });
                }
            });
    };

    return (
        <>
            <CustomDialog
                title={props.title}
                handleClose={props.handleClose}
                open={props.open}
                maxWidth={'xl'}
                fullWidth={true}
                renderContent={renderDialogContent}
                renderActions={renderDialogActions}
                disableEnforceFocus={true}
            />
        </>
    );
    // function readFile(file) {
    //     return new Promise((resolve) => {
    //         const reader = new FileReader();
    //         reader.addEventListener(
    //             'load',
    //             () => resolve(reader.result),
    //             false
    //         );
    //         reader.readAsDataURL(file);
    //     });
    // }
};
export default SendEMail;
